import { NgModule } from '@angular/core'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'

@NgModule({
  declarations: [],
  imports: [],
  exports: [MatIconModule, MatButtonModule],
})
export class MaterialModule {}
